<template>
    <div class="d-inline-block position-relative">
        <FullscreenLoading v-if="isLoading" />

        <button
            v-if="withText"
            @click="dropdownVisible = true"
            type="button"
            class="btn btn-company btn-sm rounded-pill float-right mr-2 download-dropdown-toggle"
        >
            <span class="btn-inner--icon">
                <icon name="download"></icon>
            </span>
            <span class="btn-inner--text">{{ $t('download.button_text') }}</span>
        </button>

        <button
            v-else
            @click="dropdownVisible = true"
            type="button"
            class="btn btn-xs rounded-pill btn-company-orange mr-2 download-dropdown-toggle"
        >
            <icon name="download" scale="0.8"></icon>
        </button>

        <div :class="{ show: dropdownVisible }" class="dropdown-menu dropdown-menu-sm dropdown-menu-right dropdown-menu-arrow p-3 download-dropdown">
            <h6 class="dropdown-header px-0 mb-2 text-primary">{{ $t('download.download_links') }}</h6>

            <a
                v-if="ceremony.company.block_rendering_enabled"
                class="pl-0 dropdown-item"
                v-tooltip="$t('download.tooltip_download_block_renders')"
                href="#"
                @click.prevent.stop="downloadFile('/api/ceremonies/code/'+ ceremony.code +'/download?type=block_renders', fileName + '.zip'); dropdownVisible = false"
            >
                {{ $t('download.download_block_renders') }}
            </a>
            <a
                class="pl-0 dropdown-item"
                v-tooltip="$t('download.tooltip_download_original_files')"
                href="#"
                @click.prevent.stop="downloadFile('/api/ceremonies/code/'+ ceremony.code +'/download?type=original_files', fileName + '.zip'); dropdownVisible = false"
            >
                {{ $t('download.download_original_files') }}
            </a>
        </div>
    </div>
</template>

<script setup>
    import FullscreenLoading from '../../components/FullscreenLoading.vue';
    import { computed, getCurrentInstance, onMounted, onUnmounted, ref } from 'vue';
    import Axios from 'axios';
    import { notifyError } from '../../utils/notify.js';

    const instance = getCurrentInstance();

    const props = defineProps({
        withText: {
            type: Boolean,
            default: false,
        },

        ceremony: {
            type: Object,
            required: true
        }
    });

    const isLoading = ref(false);
    const dropdownVisible = ref(false);

    const fileName = computed(() => {
        return props.ceremony.translated_type + ' - ' + props.ceremony.name;
    })

    onMounted(() => {
        document.addEventListener('click', handleClickOutside);
    });

    async function downloadFile(downloadUrl, fileName) {
        isLoading.value = true;

        try {
            const response = await Axios.get(downloadUrl, { responseType: 'blob' });

            // Attempt to extract filename from Content-Disposition header
            let filenameFromServer = fileName;
            const contentDisposition = response.headers['content-disposition'];
            if (contentDisposition && contentDisposition.indexOf('filename=') !== -1) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    filenameFromServer = match[1];
                }
            }

            const url = URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;

            // Use the filename from the server if found, else fall back to the local filename prop.
            a.download = filenameFromServer;

            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(url);
        } catch (exception) {
            notifyError(exception);
        }

        isLoading.value = false;
    }

    function handleClickOutside(event) {
        const element = instance.proxy.$el;

        const dropdown = element.querySelector('.download-dropdown');
        const dropdownToggle = element.querySelector('.download-dropdown-toggle');

        if (!dropdown || !dropdownToggle) {
            dropdownVisible.value = false;
            return;
        }

        if (!dropdown.contains(event.target) && !dropdownToggle.contains(event.target)) {
            dropdownVisible.value = false;
        }
    }

    onUnmounted(() => {
        document.removeEventListener('click', handleClickOutside);
    });

</script>
